import { render, staticRenderFns } from "./LotteryTable.vue?vue&type=template&id=f8a064e6&scoped=true&"
import script from "./LotteryTable.vue?vue&type=script&lang=js&"
export * from "./LotteryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a064e6",
  null
  
)

export default component.exports